import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
export function Objections() {
  const faqs = [{
    q: '¿Por qué cuesta solo $6.36? ¿Hay trampa?',
    a: 'Entiendo la duda — yo también la tendría. La razón es simple: este es mi precio de lanzamiento. Quiero que tantas mujeres como sea posible prueben el protocolo y vean resultados reales. Si funciona para ti (y estoy segura de que sí), se lo contarás a otras. Ese es mi marketing. No hay trampa, no hay suscripción oculta, no hay upsell agresivo. Un solo pago de $6.36 y el producto es tuyo para siempre. Y si no te funciona, te devuelvo cada centavo.'
  }, {
    q: '¿Tengo que cocinar mucho? No tengo tiempo.',
    a: 'No. El plan está diseñado para mujeres ocupadas. La mayoría de las comidas se preparan en menos de 15 minutos. Además, la guía de compras te permite comprar opciones listas para comer en supermercados de USA.'
  }, {
    q: '¿Pasaré hambre durante los 7 días?',
    a: "Absolutamente no. La Pausa Enzimática no se trata de comer menos, sino de comer lo correcto. Tendrás acceso a la 'Lista de Emergencia' con alimentos ilimitados para que nunca sientas ansiedad."
  }, {
    q: '¿Necesito suplementos o pastillas costosas?',
    a: 'Cero. Todo lo que necesitas lo encuentras en Walmart, Target, Costco o tu supermercado local. No hay batidos mágicos ni pastillas.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: "Tienes mi Garantía de 'Cintura Feliz'. Si en 7 días no te sientes desinflamada y con más energía, te devuelvo el 100% de tu dinero. Sin preguntas. El riesgo es todo mío."
  }, {
    q: '¿Es seguro si tengo más de 50 o 60 años?',
    a: 'Es ideal. Este protocolo fue creado específicamente para mujeres en perimenopausia y menopausia, cuando la inflamación es más rebelde. Es suave con tu cuerpo pero potente con la inflamación.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-155">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        <div className="text-center mb-12" data-id="element-157">
          <HelpCircle className="h-12 w-12 text-brand-gold mx-auto mb-4" data-id="element-158" />
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-159">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-600" data-id="element-160">
            Todo lo que necesitas saber antes de empezar
          </p>
        </div>

        <div className="space-y-4" data-id="element-161">
          {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-162">
              <button className="w-full flex justify-between items-center p-5 text-left bg-gray-50 hover:bg-gray-100 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-163">
                <span className="font-bold text-brand-dark text-lg pr-4" data-id="element-164">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="h-5 w-5 text-brand-gold flex-shrink-0" data-id="element-165" /> : <ChevronDown className="h-5 w-5 text-gray-400 flex-shrink-0" data-id="element-166" />}
              </button>
              {openIndex === i && <div className="p-5 bg-white text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-167">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}